import React from 'react';
import PropTypes from "prop-types";
//i18n
import { withTranslation } from "react-i18next"
import { PageContent, CustomBreadcrumb } from "components/Common"
import { ModuleIds } from "constant"
import ReportStatistic from './ReportStatistic';
// import ReportStatistic from "./ReportStatistic"

const RESOURCE = ModuleIds.ReportStatistic
const ReportStatisticContainer = ({ t }) => {
    const titleTag = `Report`
    return (
        <PageContent title={titleTag}>
            <CustomBreadcrumb
                breadcrumbItem={t("Report Statistic")}
                resource={RESOURCE}
            />
            <ReportStatistic />
        </PageContent>
    );
}

ReportStatisticContainer.propTypes = {
    t: PropTypes.any,
}

export default withTranslation(["reportPage"])(ReportStatisticContainer)